import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import easyIcon from '../../assets/easy.png';
import mediumIcon from '../../assets/medium.png';
import hardIcon from '../../assets/hard.png';

function DifficultyModal({ show, onHide, onSelect, gameName }) {
  const [selectedDifficulty, setSelectedDifficulty] = useState(null);

  const difficulties = [
    {
      level: 'easy',
      name: 'Einfach',
      icon: easyIcon,
      description: 'Perfekt für Anfänger',
      color: '#00D4AA'
    },
    {
      level: 'medium',
      name: 'Mittel',
      icon: mediumIcon,
      description: 'Für Fortgeschrittene',
      color: '#FFD93D'
    },
    {
      level: 'hard',
      name: 'Schwer',
      icon: hardIcon,
      description: 'Für Experten',
      color: '#FF6B6B'
    }
  ];

  const getGameRules = () => {
    const rules = {
      'Memory Spiel': (
        <>
          <div style={{
            backgroundColor: '#E8F4F8',
            border: '2px solid #B8D4E3',
            borderRadius: '10px',
            padding: '1rem',
            marginBottom: '1rem'
          }}>
            <h4 style={{
              fontSize: '15px',
              fontWeight: 'bold',
              color: '#2C5F7A',
              marginBottom: '0.75rem',
              marginTop: 0
            }}>
              Modul 1
            </h4>
            <p style={{ margin: 0, color: '#4A4A4A' }}>
              Versuchen Sie gemeinsam mit Ihrem Kind, bei den aufgedeckten Wörtern die Ziellaute und Ersatzlaute herauszuhören. So trainieren Sie spielerisch das genaue Hinhören und die Lautunterscheidung.
            </p>
          </div>

          <div style={{
            backgroundColor: '#F0F8E8',
            border: '2px solid #C7E9C7',
            borderRadius: '10px',
            padding: '1rem',
            marginBottom: '1rem'
          }}>
            <h4 style={{
              fontSize: '15px',
              fontWeight: 'bold',
              color: '#3D7A3D',
              marginBottom: '0.75rem',
              marginTop: 0
            }}>
              Modul 2
            </h4>
            <p style={{ marginBottom: '0.8rem', color: '#4A4A4A' }}>
              👉 Benennen Sie die aufgedeckten Wörter immer wieder gemeinsam. Kann Ihr Kind die Wörter schon sicher aussprechen, können Sie das Spiel erweitern: Verbinden Sie zwei Wörter, auch wenn sie kein Paar bilden – und sprechen Sie sie zusammen als neues Fantasiewort aus.
            </p>
            <p style={{
              margin: 0,
              fontWeight: 'bold',
              color: '#4A4A4A',
              backgroundColor: '#ffffff',
              padding: '0.75rem',
              borderRadius: '8px'
            }}>
              Beispiel: Fuß + Socke = Fußsocke
            </p>
          </div>
        </>
      ),
      'Wörter verbinden': (
        <>
          <div style={{
            backgroundColor: '#E8F4F8',
            border: '2px solid #B8D4E3',
            borderRadius: '10px',
            padding: '1rem',
            marginBottom: '1rem'
          }}>
            <h4 style={{
              fontSize: '15px',
              fontWeight: 'bold',
              color: '#2C5F7A',
              marginBottom: '0.75rem',
              marginTop: 0
            }}>
              Modul 1
            </h4>
            <p style={{ margin: 0, color: '#4A4A4A' }}>
              Üben Sie mit Ihrem Kind gezielt das Hören von Lauten. Nennen Sie ein Wort und fragen Sie: „Welches Geräusch hörst du – das „S" oder „Sch"?" oder „Ist das ein Ziel- oder Ersatzlaut?". So fördern Sie das genaue Hinhören und Erkennen der Laute.
            </p>
          </div>

          <div style={{
            backgroundColor: '#F0F8E8',
            border: '2px solid #C7E9C7',
            borderRadius: '10px',
            padding: '1rem',
            marginBottom: '1rem'
          }}>
            <h4 style={{
              fontSize: '15px',
              fontWeight: 'bold',
              color: '#3D7A3D',
              marginBottom: '0.75rem',
              marginTop: 0
            }}>
              Modul 2
            </h4>
            <p style={{ marginBottom: '0.8rem', color: '#4A4A4A' }}>
              Benennen Sie die Zielwörter auf Wortebene gemeinsam korrekt. Wenn Sie bereits auf Satzebene arbeiten, bilden Sie gemeinsam einfache, passende Sätze. Achten Sie darauf, dass der Ziellaut im Satz enthalten ist und wiederholt wird. Durch das Einbetten der Wörter in vollständige Sätze wird die Lautverwendung im Sprachfluss gefestigt.
            </p>
            <div style={{
              backgroundColor: '#ffffff',
              padding: '0.75rem',
              borderRadius: '8px'
            }}>
              <p style={{ margin: 0, marginBottom: '0.5rem', color: '#4A4A4A' }}>
                Da<strong>s</strong> Fen<strong>s</strong>ter pa<strong>ss</strong>t zum Hau<strong>s</strong>.
              </p>
              <p style={{ margin: 0, color: '#4A4A4A' }}>
                Der Ba<strong>gg</strong>er <strong>g</strong>ehört zur Baustelle.
              </p>
            </div>
          </div>

          <div style={{
            backgroundColor: '#FFF9E6',
            border: '2px solid #FFE4A3',
            borderRadius: '10px',
            padding: '1rem',
            marginBottom: '1rem'
          }}>
            <h4 style={{
              fontSize: '15px',
              fontWeight: 'bold',
              color: '#856404',
              marginBottom: '0.75rem',
              marginTop: 0
            }}>
              Wörter verbinden:
            </h4>
            <p style={{ margin: 0, color: '#4A4A4A' }}>
              Verbinden Sie die zusammengehörenden Wörter. So üben Sie spielerisch Ihre Ziellaute und erweitern gleichzeitig Ihren Wortschatz.
            </p>
          </div>
        </>
      ),
      'Laut-Detektive': (
        <>
          <div style={{
            backgroundColor: '#E8F4F8',
            border: '2px solid #B8D4E3',
            borderRadius: '10px',
            padding: '1rem',
            marginBottom: '0.75rem'
          }}>
            <p style={{ margin: 0, color: '#4A4A4A', fontSize: '14px', lineHeight: '1.6' }}>
              <strong>1. Bereitlegen:</strong> Nehmen Sie sich Ihre Lautsymbolkarten Ihrer Ziel-und Ersatzlaute und legen Sie diese gut sichtbar vor sich hin.
            </p>
          </div>

          <div style={{
            backgroundColor: '#F0F8E8',
            border: '2px solid #C7E9C7',
            borderRadius: '10px',
            padding: '1rem',
            marginBottom: '0.75rem'
          }}>
            <p style={{ margin: 0, color: '#4A4A4A', fontSize: '14px', lineHeight: '1.6' }}>
              <strong>2. Auswählen:</strong> Wählen Sie diese auch für das Spiel aus und starten.
            </p>
          </div>

          <div style={{
            backgroundColor: '#FFF9E6',
            border: '2px solid #FFE4A3',
            borderRadius: '10px',
            padding: '1rem',
            marginBottom: '0.75rem'
          }}>
            <p style={{ margin: 0, color: '#4A4A4A', fontSize: '14px', lineHeight: '1.6' }}>
              <strong>3. Hören:</strong> Auf dem Bildschirm sehen Sie zwei Wörter, z. B. Kanne und Teller. Eines der Wörter werden Ihnen vorgesprochen.
            </p>
            <p style={{ margin: '0.75rem 0 0 0', color: '#4A4A4A', fontSize: '14px', lineHeight: '1.6' }}>
              👉 Hören Sie gemeinsam genau zu: <strong>„Welches Wort wurde gesagt?"</strong>
            </p>
          </div>

          <div style={{
            backgroundColor: '#FFE8F0',
            border: '2px solid #FFCCE0',
            borderRadius: '10px',
            padding: '1rem',
            marginBottom: '0.75rem'
          }}>
            <p style={{ margin: 0, color: '#4A4A4A', fontSize: '14px', lineHeight: '1.6' }}>
              <strong>4. Zuordnen:</strong> Klicken Sie auf das Wort, das Sie gehört haben, und entscheiden gemeinsam welches das passende Lautsymbol dazu ist. Fragen Sie ihr Kind welches Geräusch/Bild zu dem Wort passt <em>„War es das Schlangengeräusch oder die Schnecke?"</em>
            </p>
          </div>

          <div style={{
            backgroundColor: '#F5F0FF',
            border: '2px solid #D4C5F9',
            borderRadius: '10px',
            padding: '1rem',
            marginBottom: '1rem'
          }}>
            <p style={{ margin: 0, color: '#4A4A4A', fontSize: '14px', lineHeight: '1.6' }}>
              <strong>5. Loben & wiederholen:</strong> Loben Sie Ihr Kind für gutes Zuhören und spielen Sie mehrere Runden, bis die Laute sicher erkannt werden.
            </p>
          </div>
        </>
      ),
      'Geschichte erzählen': (
        <>
          <div style={{
            backgroundColor: '#E8F4F8',
            border: '2px solid #B8D4E3',
            borderRadius: '10px',
            padding: '1rem',
            marginBottom: '1rem'
          }}>
            <h4 style={{
              fontSize: '15px',
              fontWeight: 'bold',
              color: '#2C5F7A',
              marginBottom: '0.75rem',
              marginTop: 0
            }}>
              Ziel des Spiels
            </h4>
            <p style={{ margin: 0, color: '#4A4A4A' }}>
              In diesem Spiel übt Ihr Kind, den ausgewählten Ziellaut nicht nur in einzelnen Wörtern, sondern in vollständigen Sätzen anzuwenden. Durch das freie Geschichtenerzählen wird der Laut schrittweise in die Spontansprache integriert – ein wichtiger Schritt zur sicheren Lautverwendung im Alltag.
            </p>
          </div>

          <div style={{
            backgroundColor: '#F0F8E8',
            border: '2px solid #C7E9C7',
            borderRadius: '10px',
            padding: '1rem',
            marginBottom: '1rem'
          }}>
            <h4 style={{
              fontSize: '15px',
              fontWeight: 'bold',
              color: '#3D7A3D',
              marginBottom: '0.75rem',
              marginTop: 0
            }}>
              So funktioniert's
            </h4>
            <ol style={{ margin: '0 0 0 1.25rem', paddingLeft: 0, color: '#4A4A4A' }}>
              <li style={{ marginBottom: '0.5rem' }}>Wählen Sie gemeinsam mit Ihrem Kind den gewünschten Ziellaut aus</li>
              <li style={{ marginBottom: '0.5rem' }}>Suchen Sie passende Bilder aus oder nutzen Sie den Zufalls-Button (✨) für eine Überraschung</li>
              <li style={{ marginBottom: '0.5rem' }}>Lassen Sie Ihr Kind eine zusammenhängende Geschichte erfinden, in der alle ausgewählten Bilder vorkommen</li>
              <li style={{ marginBottom: '0.5rem' }}>Achten Sie darauf, dass der Ziellaut in vollständigen Sätzen verwendet wird</li>
              <li style={{ marginBottom: 0 }}>Markieren Sie die Bilder während des Erzählens als "verwendet" (✓), um den Fortschritt zu verfolgen</li>
            </ol>
          </div>

          <div style={{
            backgroundColor: '#FFF9E6',
            border: '2px solid #FFE4A3',
            borderRadius: '10px',
            padding: '1rem',
            marginBottom: '1rem'
          }}>
            <h4 style={{
              fontSize: '15px',
              fontWeight: 'bold',
              color: '#856404',
              marginBottom: '0.75rem',
              marginTop: 0
            }}>
              Schwierigkeitsstufen
            </h4>
            <ul style={{ margin: '0 0 0 1.25rem', paddingLeft: 0, color: '#4A4A4A' }}>
              <li style={{ marginBottom: '0.5rem' }}>
                <strong>Einfach:</strong> 3 Bilder (Wortbilder + Geschichtenbilder, falls vorhanden). Ideal für den Einstieg – kurze Geschichten mit visueller Unterstützung.
              </li>
              <li style={{ marginBottom: '0.5rem' }}>
                <strong>Mittel:</strong> 4 Bilder (Wortbilder + Geschichtenbilder, falls vorhanden). Etwas mehr Kreativität gefragt – längere Geschichten mit mehreren Elementen.
              </li>
              <li style={{ marginBottom: 0 }}>
                <strong>Schwer:</strong> 5 beliebige Bilder. Für Fortgeschrittene – freies, kreatives Erfinden eigener Geschichten.
              </li>
            </ul>
          </div>

          <div style={{
            backgroundColor: 'rgb(255, 232, 240)',
            border: '2px solid rgb(255, 204, 224)',
            borderRadius: '10px',
            padding: '1rem'
          }}>
            <p style={{ margin: 0, color: '#4A4A4A', fontStyle: 'italic' }}>
              <strong>💡 Tipp:</strong> Je sicherer Ihr Kind den Ziellaut bereits beherrscht, desto höher können Sie den Schwierigkeitsgrad wählen. Das Üben entwickelt sich so ganz natürlich – vom einfachen Nacherzählen bis hin zum freien Geschichtenerzählen!
            </p>
          </div>
        </>
      ),
      'Sprechhelden auf Lautsuche': (
        <>
          <div style={{
            backgroundColor: '#E8F4F8',
            border: '2px solid #B8D4E3',
            borderRadius: '10px',
            padding: '1rem',
            marginBottom: '1rem'
          }}>
            <p style={{ margin: 0, color: '#4A4A4A' }}>
              In diesem Spiel suchen Sie gemeinsam mit Ihrem Kind die Ziellaute in den Bildern. So können die passenden Wörter und Geräusche spielerisch geübt werden.
            </p>
          </div>

          <div style={{
            backgroundColor: '#F0F8E8',
            border: '2px solid #C7E9C7',
            borderRadius: '10px',
            padding: '1rem',
            marginBottom: '1rem'
          }}>
            <p style={{ margin: 0, color: '#4A4A4A' }}>
              In Modul 3 lässt sich das Spiel außerdem nutzen, um erste freie Sätze zu den Bildern zu bilden oder kleine Geschichten dazu zu erzählen.
            </p>
          </div>
        </>
      )
    };

    return rules[gameName] || '[Platzhalter für Spielregeln - wird später mit den tatsächlichen Regeln des Spiels ersetzt]';
  };

  const handleSelect = () => {
    // For games without difficulty selection, pass a default value
    if (gameName === 'Laut-Detektive') {
      onSelect('medium'); // Default difficulty for games without selection
      onHide();
    } else if (selectedDifficulty) {
      onSelect(selectedDifficulty);
      onHide();
      setSelectedDifficulty(null);
    }
  };

  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      size="lg" 
      centered
      className="difficulty-modal"
    >
      <Modal.Header closeButton style={{ 
        borderBottom: '2px solid #dee2e6',
        backgroundColor: '#f8f9fa',
        borderRadius: '0.375rem 0.375rem 0 0'
      }}>
      </Modal.Header>
      <Modal.Body style={{ padding: '2rem' }}>
        <h3 style={{
          fontSize: '20px',
          fontWeight: 'bold',
          color: '#4A4A4A',
          marginBottom: '0.5rem',
          textAlign: 'center'
        }}>
          Spielregeln
        </h3>

        <div style={{
          backgroundColor: '#ffffff',
          borderRadius: '10px',
          fontSize: '14px',
          color: '#7A7A7A',
          lineHeight: '1.6'
        }}>
          {getGameRules()}
        </div>

        {gameName !== 'Laut-Detektive' && (
          <>
            <p className="text-center mb-4" style={{
              fontSize: '16px',
              color: '#7A7A7A',
              marginTop: '2.5rem',
              marginBottom: '1.5rem'
            }}>
              Wähle den passenden Schwierigkeitsgrad für dein Kind
            </p>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(130px, 1fr))',
              gap: '15px',
              maxWidth: '500px',
              margin: '0 auto'
            }}>
              {difficulties.map(diff => (
            <div
              key={diff.level}
              onClick={() => setSelectedDifficulty(diff.level)}
              style={{
                padding: '1rem',
                borderRadius: '12px',
                border: '2px solid',
                borderColor: selectedDifficulty === diff.level ? '#88D8B0' : '#dee2e6',
                backgroundColor: selectedDifficulty === diff.level ? '#88D8B0' : '#ffffff',
                color: selectedDifficulty === diff.level ? '#4A4A4A' : '#7A7A7A',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                textAlign: 'center',
                minHeight: '110px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center'
              }}
              onMouseEnter={(e) => {
                if (selectedDifficulty !== diff.level) {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.borderColor = '#88D8B0';
                }
              }}
              onMouseLeave={(e) => {
                if (selectedDifficulty !== diff.level) {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.borderColor = '#dee2e6';
                }
              }}
            >
              <div style={{
                marginBottom: '0.5rem',
                width: '40px',
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <img
                  src={diff.icon}
                  alt={diff.name}
                  style={{
                    width: '40px',
                    height: '40px',
                    objectFit: 'contain'
                  }}
                />
              </div>
              <h5 style={{
                margin: 0,
                fontSize: '1rem',
                fontWeight: 'bold'
              }}>
                {diff.name}
              </h5>
            </div>
          ))}
        </div>
          </>
        )}
      </Modal.Body>
      <Modal.Footer style={{ 
        borderTop: '2px solid #dee2e6',
        backgroundColor: '#f8f9fa',
        borderRadius: '0 0 0.375rem 0.375rem',
        display: 'flex',
        justifyContent: 'center'
      }}>
        <Button
          onClick={handleSelect}
          disabled={gameName !== 'Laut-Detektive' && !selectedDifficulty}
          style={{
            minWidth: '150px',
            minHeight: '60px',
            borderRadius: '30px',
            backgroundColor: (gameName === 'Laut-Detektive' || selectedDifficulty) ? '#88D8B0' : '#dee2e6',
            border: '2px solid',
            borderColor: (gameName === 'Laut-Detektive' || selectedDifficulty) ? '#88D8B0' : '#dee2e6',
            color: (gameName === 'Laut-Detektive' || selectedDifficulty) ? '#4A4A4A' : '#7A7A7A',
            fontWeight: 'bold',
            fontSize: '16px',
            transition: 'all 0.3s ease',
            cursor: (gameName === 'Laut-Detektive' || selectedDifficulty) ? 'pointer' : 'not-allowed'
          }}
          onMouseEnter={(e) => {
            if (gameName === 'Laut-Detektive' || selectedDifficulty) {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.borderColor = '#5cad7f';
            }
          }}
          onMouseLeave={(e) => {
            if (gameName === 'Laut-Detektive' || selectedDifficulty) {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.borderColor = '#88D8B0';
            }
          }}
        >
          Spiel starten
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default DifficultyModal;